"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscribed = isSubscribed;
const interfaces_1 = require("@lotr/interfaces");
function isSubscribed(account) {
    return (account.isGameMaster ||
        account.isTester ||
        (account.premium?.subscriptionTier ?? interfaces_1.SubscriptionTier.None) >
            interfaces_1.SubscriptionTier.None);
}
